<template>
  <div class="container">
    <div class="row" v-for="round in completedRounds" v-bind:key="round.number" >
      <div class="col">
        {{round.number}}
        <span v-if="totalRounds">of {{totalRounds}}</span>
      </div>
      <div class="col" v-for="player in players" :key="player.name" contenteditable="true">
        {{round.playerScores[player.name].score}}
      </div>
    </div>
    <currentround v-for="round in incompleteRounds" :gameId="game.id"  :gameOver="gameOver" v-bind:key="round.number" :round="round" :totalRounds="totalRounds" :players="players" :playerTurn="game.playerTurn"/>
  </div>
</template>

<script>
import currentround from "./CurrentRound"

export default {
    name: "rounds",
    components: {
        currentround    
    },
    props: {
        game: Object,
        rounds: Array,
        players: Array,
        gameOver: Boolean
    },
    computed: {
      currentRound: function() {
        return this.game.currentRound.number
      },
      totalRounds: function() {
        return this.game.totalRounds
      },
      completedRounds: function() {
        return this.game.rounds.filter(round => round.complete)
      },
      incompleteRounds: function() {
        return this.game.rounds.filter(round => !round.complete)
      }
    }
};
</script>

<style scoped>
.container {
  display: flex; /* or inline-flex */
  flex-direction: column;
}

.row {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: space-around;
  align-content: center;
  justify-content: space-between;
}
.row > * {
  flex: 1 100%;
}

.col {
  padding: 5px;
  
  line-height: 15px;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}

.row:nth-child(even){
  background-color: #f9f9f9;
}
.row:nth-child(odd){
  background-color: #ffffff;
}
</style>